import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import CountrySelector from "../shared/country-selector";
import LanguageSelector from "../shared/language-selector";
import ChannelsList from "../shared/channels-list";

const Channels = observer((props: ContextProps) => {
    const context = props.context;
    const dictionary = context.dictionary;

    if (!context.displayChannelMenu) {
        return null;
    }

    return (<nav className="channel-menu">
        <div className="channel-menu-container">
            {context.channels.length > 0 && <div className="channels">
                <label>{dictionary.externalSitesTitle}</label>
                <ChannelsList context={context} className="channels" />
            </div>}

            <fieldset>
                <div className="selector">
                    <label>{dictionary.countrySelector}</label>
                    <CountrySelector context={context} />
                </div>

                {context.country.languages.length > 1 && <div className="selector">
                    <label>{dictionary.languageSelector}</label>
                    <LanguageSelector context={context} />
                </div>}
            </fieldset>
        </div>
    </nav>);
});

export default Channels;